enum ColorGroups {
  POPULAR = 'Popular',
  WHITE = 'Whites',
  GRAY = 'Grays',
  BROWN = 'Browns',
  RED = 'Reds',
  ORANGE = 'Oranges',
  YELLOW = 'Yellows',
  GREEN = 'Greens',
  BLUE = 'Blues',
  PURPLE = 'Purples',
}

enum JhColorGroups {
  MAGNOLIA = 'Magnolia',
  STATEMENT = 'Statement',
  DREAM = 'Dream',
}

const BASE_WHITE_HEX_CODE = '#ffffff';

const ColorGroupLabelColors: { [key: string]: string } = {};
ColorGroupLabelColors[ColorGroups.WHITE] = '#ffffff';
ColorGroupLabelColors[ColorGroups.GRAY] = '#808183';
ColorGroupLabelColors[ColorGroups.BROWN] = '#996633';
ColorGroupLabelColors[ColorGroups.RED] = '#E44B3A';
ColorGroupLabelColors[ColorGroups.ORANGE] = '#F37500';
ColorGroupLabelColors[ColorGroups.YELLOW] = '#FCEC00';
ColorGroupLabelColors[ColorGroups.GREEN] = '#00A850';
ColorGroupLabelColors[ColorGroups.BLUE] = '#1472A5';
ColorGroupLabelColors[ColorGroups.PURPLE] = '#B933AD';

export {
  ColorGroups,
  ColorGroupLabelColors,
  JhColorGroups,
  BASE_WHITE_HEX_CODE,
};
